import InvoicingBill from "./SVG/invoicing-bill.svg?react";

const InvoicingBillIcon = () => {
  return <InvoicingBill />;
};

export default InvoicingBillIcon;
